import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

const AddProjectModal = ({
    show,
    onHide,
    selectedClient,
    setSelectedClient,
    projectName,
    setProjectName,
    startDate,
    setStartDate,
    dueDate,
    setDueDate,
    estimatedBudget,
    setEstimatedBudget,
    estimatedTime,
    setEstimatedTime,
    selectedPriority,
    setSelectedPriority,
    selectedAssignees,
    setSelectedAssignees,
    description,
    setDescription,
    profitMargin,
    setProfitMargin,
    targetProfit,
    setTargetProfit,
    targetCosts,
    setTargetCosts,
    financialProposal,
    setFinancialProposal,
    paymentStatus,
    setPaymentStatus,
    projectStatus,
    setProjectStatus,
    clientOptions,
    priorityOptions,
    assigneeOptions,
    paymentOptions,
    statusOptions
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered  size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Add New Project</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className='gy-3'>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Client <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedClient}
                                        onChange={setSelectedClient}
                                        options={clientOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Project Name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={projectName}
                                        onChange={(e) => setProjectName(e.target.value)}
                                        placeholder=""
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Start Date</Form.Label>
                                    <Flatpickr
                                        value={startDate}
                                        onChange={([date]) => setStartDate(date)}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                            time_24hr: false
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>End Date</Form.Label>
                                    <Flatpickr
                                        value={dueDate}
                                        onChange={([date]) => setDueDate(date)}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            minDate: startDate,
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                            time_24hr: false
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Estimated Time</Form.Label>
                                    <Form.Control type="text" />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Priority</Form.Label>
                                    <Select
                                        value={selectedPriority}
                                        onChange={setSelectedPriority}
                                        options={priorityOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Budget</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={estimatedBudget}
                                        onChange={(e) => setEstimatedBudget(e.target.value)}
                                        placeholder=""
                                        min={0}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Payment Status</Form.Label>
                                    <Select
                                        value={paymentStatus}
                                        onChange={setPaymentStatus}
                                        options={paymentOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Project Status</Form.Label>
                                    <Select
                                        value={projectStatus}
                                        onChange={setProjectStatus}
                                        options={statusOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Assignees <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedAssignees}
                                        onChange={setSelectedAssignees}
                                        options={assigneeOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={3}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group className="mb-4">
                                    <Form.Label>Financial Proposal</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={(e) => setFinancialProposal(e.target.files[0])}
                                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                                    />
                                    <Form.Text className="text-muted">
                                        Supported formats: PDF, DOC, DOCX, XLS, XLSX
                                    </Form.Text>
                                </Form.Group>

                                <div className="border-top pt-4">
                                    <div className="mb-3 fs-18 fw-bold">Financial Targets</div>
                                    <Row className="gy-3">
                                        <Col sm={4}>
                                            <Form.Group>
                                                <Form.Label>Profit Margin (%)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={profitMargin}
                                                    onChange={(e) => setProfitMargin(e.target.value)}
                                                    min={0}
                                                    max={100}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group>
                                                <Form.Label>Target Profit</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={targetProfit}
                                                    onChange={(e) => setTargetProfit(e.target.value)}
                                                    min={0}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group>
                                                <Form.Label>Target Costs</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={targetCosts}
                                                    onChange={(e) => setTargetCosts(e.target.value)}
                                                    min={0}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onHide}>
                    Add Project
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddProjectModal;
